import { FaUsers, FaBuilding, FaLaptopCode, FaHardHat, FaCog, FaShieldAlt } from "react-icons/fa";

// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <FaUsers />,
    title: "Entrepreneurship",
    des: "Igniting change with innovative ideas, I turn challenges into opportunities, creating value in every venture.",
  },
  {
    id: 2,
    icon: <FaLaptopCode />,
    title: "Software Engineering",
    des: "Crafting seamless digital solutions, my software engineering skills solve complex problems with efficiency",
  },
  {
    id: 3,
    icon: <FaCog />,
    title: "Mechanical Engineering",
    des: "Designing mechanical systems, I turn theoretical concepts into practical applications with precision.",
  },
  {
    id: 4,
    icon: <FaBuilding />,
    title: "Building Information Modeling (BIM)",
    des: "Enhancing construction with BIM, I streamline processes and optimize outcomes for accurate project execution.",
  },
  {
    id: 5,
    icon: <FaHardHat />,
    title: "Construction Engineering Management",
    des: "Excelling in Construction Engineering Management, I ensure projects are completed efficiently and on time.",
  },
  {
    id: 6,
    icon: <FaShieldAlt />,
    title: "Occupational Safety and Health",
    des: "Prioritizing safety, I implement protocols that minimize risks and promote a healthy work environment.",
  },
];
